/* AgeGO checkout gate */
(function () {
  'use strict';

  var TRIGGERS = [
    '[name="checkout"]',
    'a[href^="/checkout"]',
    'a[href^="/cart/checkout"]'
  ].join(',');

  var ALLOW = 'data-agego-allow';
  var pending = null;
  var launching = false;

  function customerIsVerified() {
    var c = window.AgeGoCustomer;
    if (!c || !c.verifiedUntil) return false;

    var until = Date.parse(c.verifiedUntil);
    return !isNaN(until) && until > Date.now();
  }

  function reset() {
    launching = false;
    pending = null;
  }

  function proceed() {
    var el = pending;
    reset();

    if (!el) return;

    el.setAttribute(ALLOW, '1');

    if (el.tagName === 'A') {
      window.location.assign(el.href);
      return;
    }

    var form = el.form || (el.closest && el.closest('form'));

    if (form) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = el.getAttribute('name') || 'checkout';
      hidden.value = el.getAttribute('value') || '';
      form.appendChild(hidden);

      form.submit();
      return;
    }

    el.click();
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest(TRIGGERS) : null;

    if (!el) return;

    if (el.getAttribute(ALLOW) === '1') return;

    var owner = el.form || (el.closest && el.closest('form'));

    if (
      el.tagName !== 'A' &&
      !(owner && (owner.getAttribute('action') || '').indexOf('/cart') === 0)
    ) {
      return;
    }

    if (customerIsVerified()) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (launching) return;

    launching = true;
    pending = el;

    window.AGEGO('launch');
  }, true);

  window.AgeGoGate = {
    onVerified: function (data) {
      if (!window.AgeGoCustomer || !window.AgeGoCustomer.id) {
        return proceed();
      }

      var done = function () {
        proceed();
      };

      fetch('/apps/agego/verified', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(done, done);
    },

    onAlreadyVerified: function () {
      if (launching) proceed();
    },

    onAbandoned: function () {
      reset();
    },

    onFailed: function () {
      reset();
    },

    onExpired: function () {
      reset();
    }
  };
})();